import { FC } from "react";
import React from "react";
import AppDialog from "../AppDialog/AppDialog";
import Translate from "../Translate/Translate";

const SessionConfirmation: FC<{
  onConfirmed?: () => void;
  onLogout?: () => void;
  firstName?: string;
  lastName?: string;
}> = ({ onConfirmed, onLogout, firstName, lastName }) => {
  const handleContinue = () => {
    onConfirmed?.();
  };

  const handleClose = (args?: { via: "cancel" | "close" }) => {
    if (args?.via === "cancel") {
      onLogout?.();
    }
  };

  if (!firstName && !lastName) {
    return null;
  }

  return (
    <AppDialog
      confirmText={"yesContinue"}
      cancelText={"noLogOut"}
      onClose={handleClose}
      confirmArrow={false}
      onCancel={handleClose}
      onConfirm={handleContinue}
    >
      <h5>
        <Translate
          msg="sessionConfirmation.title"
          variables={{ firstName, lastName }}
        />
      </h5>
      <p>
        <Translate msg="sessionConfirmation.description" />
      </p>
    </AppDialog>
  );
};

export default SessionConfirmation;
